export default __webpack_public_path__ + "static/media/doubleCoronaOpen.48116e44.jpg";